import React, { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';

import { ESIGNATURE_PAGE_MARGIN } from 'src/constants';
import { ContractBuilderContext } from 'src/context/contractBuilderContext';
import { SignaturePageImageData } from 'src/store/signaturePage/types';
import { RegularCardShadow } from 'src/theme/shadows';

const useStyles = makeStyles<{ pageMargin: number }>()((_, props) => ({
  root: {
    width: '100%',
    pointerEvents: 'none' as const,
    marginBottom: props.pageMargin,
    borderRadius: 4,
    overflow: 'hidden' as const,
    boxShadow: RegularCardShadow,
    '& >img': {
      width: '100%',
    },
  },
}));

interface SignaturePageImageProps {
  pageImage: SignaturePageImageData;
  handlePageImageLoad: (event: React.SyntheticEvent<HTMLImageElement>) => void;
}

export const SignaturePageImage = React.forwardRef<
  HTMLDivElement,
  SignaturePageImageProps
>((props, ref) => {
  const { pageImage, handlePageImageLoad } = props;

  const { pageScalerFactor } = useContext(ContractBuilderContext);

  const { classes } = useStyles({
    // the pixel density on mobile devices is higher than on desktop
    // so we need to adjust the page margin accordingly using the page scaler factor
    // This is to ensure the y position of the signature component is consistent across devices
    pageMargin: ESIGNATURE_PAGE_MARGIN / pageScalerFactor,
  });

  return (
    <div className={classes.root} ref={ref}>
      <img
        src={pageImage.url}
        data-testid={`page-image-${pageImage.key}`}
        crossOrigin="anonymous"
        alt={`document_page_${pageImage.pageNumber}`}
        onLoad={handlePageImageLoad}
      />
    </div>
  );
});
